import { generateClient, GraphQLResult } from 'aws-amplify/api';
import { v4 as uuidv4 } from 'uuid';
import {
  EmailSpaceUrlToSelfMutation,
  EntryType,
  GetNewStripeConfigMutation,
  OriginObjectType,
  SharedContentBoard,
  SharedContentBoardEntry,
  SharedContentBoardLane,
} from '../API';
import * as mutations from '../graphql/mutations';
import { spaceContentBoardEntryByEntryID } from '../services/spaces';
import { cloneObject } from './utils';
import { appSyncGraphQLApi } from '../app/smorgAppSyncGraphQLApi';

const client = generateClient();

// export const migrateSpaceOperation = async (space: Space) => {
//   if (space.spaceContentBoard && !space.spaceSharedContentBoardIDs) {
//     const extractedSharedContentBoard = {
//       id: space.spaceContentBoard.id,
//       title: space.spaceContentBoard.title,
//       groups: space.groups,
//       lanes: space.spaceContentBoard.lanes.map((spaceContentLane) => ({
//         id: spaceContentLane.id,
//         title: spaceContentLane.title,
//         entries: spaceContentLane.entries.map((spaceContentEntry) => ({
//           id: spaceContentEntry.id,
//           entryType: spaceContentEntry.entryType,
//           objectID: spaceContentEntry.objectID,
//         })),
//       })),
//     } as SharedContentBoard;
//     const savedSharedContentBoard = await createSharedContentBoardOperation(
//       extractedSharedContentBoard,
//     );
//     if (!savedSharedContentBoard) {
//       throw new Error('Failed to create SharedContentBoard');
//     }
//     const migratedSpace = {
//       ...space,
//       spaceContentBoard: null,
//       spaceSharedContentBoardIDs: [savedSharedContentBoard.id],
//     };
//     const savedSpace = await updateSpaceOperation(migratedSpace);
//     return savedSpace;
//   }
//   return space;
// // };

// export const listAndMigrateOwnedSpacesOperation = async () => {
//   const unmigratedSpaces = await listOwnedSpacesOperation();
//   const migratedSpaces = await Promise.all(
//     unmigratedSpaces.map(migrateSpaceOperation),
//   );
//   return migratedSpaces;
// };

export const emailSpaceUrlToSelfOperation = async (spaceUrl: string) => {
  const response = (await client.graphql({
    query: mutations.emailSpaceUrlToSelf,
    variables: { spaceUrl },
  })) as GraphQLResult<EmailSpaceUrlToSelfMutation>;
  return response.data?.emailSpaceUrlToSelf;
};

export const getNewStripeConfigOperation = async (
  authorizationCode: string,
) => {
  const response = (await client.graphql({
    query: mutations.getNewStripeConfig,
    variables: {
      authorizationCode,
    },
  })) as GraphQLResult<GetNewStripeConfigMutation>;
  return response.data?.getNewStripeConfig;
};

export const spaceContentBoardEntryQuickDuplicate = async (
  sharedContentBoard: SharedContentBoard,
  entryID: string,
  lazyGetSharedContentEntry: ReturnType<
    typeof appSyncGraphQLApi.useLazyGetSharedContentEntryQuery
  >[0],
  createSharedContentEntry: ReturnType<
    typeof appSyncGraphQLApi.useCreateSharedContentEntryMutation
  >[0],
  updateSharedContentBoard: ReturnType<
    typeof appSyncGraphQLApi.useUpdateSharedContentBoardMutation
  >[0],
) => {
  const entry = spaceContentBoardEntryByEntryID(sharedContentBoard, entryID);
  if (!entry) {
    return;
  }
  let newObject: { id: string } | null | undefined = null;

  if (entry.entryType === EntryType.CONTENT_ENTRY) {
    const { data: sharedContentEntry } = await lazyGetSharedContentEntry(
      entry.objectID,
    );
    const clonedSharedContentEntry = cloneObject(sharedContentEntry);
    console.log({ clonedSharedContentEntry });
    const input = {
      ...clonedSharedContentEntry,
      parentID: sharedContentBoard.id,
      origin: {
        originObjectType: OriginObjectType.CONTENT_ENTRY,
        originObjectID: entry.objectID,
      },
    };

    const { data: insertedSharedContentEntry } = await createSharedContentEntry(
      input,
    );
    newObject = insertedSharedContentEntry;
  }

  const updatedLanes = sharedContentBoard.lanes.map(
    (lane: SharedContentBoardLane) => {
      const entryIndexToDuplicate = lane.entries.findIndex(
        (e) => e.id === entryID,
      );
      if (entryIndexToDuplicate === -1) {
        return lane;
      }
      const newEntry = {
        id: uuidv4(),
        entryType: entry.entryType,
        objectID: newObject
          ? newObject.id
          : lane.entries[entryIndexToDuplicate].objectID,
      } as SharedContentBoardEntry;
      const updatedEntries = [...lane.entries];
      updatedEntries.splice(entryIndexToDuplicate, 0, newEntry);
      return {
        ...lane,
        entries: updatedEntries,
      };
    },
  );

  const updatedBoard = {
    ...sharedContentBoard,
    lanes: updatedLanes,
  };

  await updateSharedContentBoard(updatedBoard);
};
